import React from 'react';
import {Card,Button} from '@mui/material';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import CardActionArea from '@mui/material/CardActionArea';
import CardContent from '@mui/material/CardContent';
import CardMedia from '@mui/material/CardMedia';
import * as ETVConstants from '../ETVConstants';

class DirectoryItem extends React.Component {

    getDirName( dir) {
      var dirLastPart = dir;
      if(dirLastPart.endsWith("/")) {
        dirLastPart = dirLastPart.substring(0,dirLastPart.lastIndexOf("/"));
      }
      dirLastPart = dirLastPart.substring(dirLastPart.lastIndexOf("/")+1);
      return dirLastPart;
    }

    render() {
      var dir = this.props.directory;
      var isUp = this.props.isUp;
      return (
        isUp?
          <Card style={{width:100,height:180,margin:5,padding:20}}>
            <CardMedia component="img" image="/icons/folder_up.png" alt="back" title="up" onClick={()=>{ this.props.dirClickedFunc(dir)}}/>
            <CardContent>
              <Typography align="center" variant="body2">{ETVConstants.trans("back")}</Typography>
            </CardContent>
          </Card>
          :
          <Card style={{width:100,height:180,margin:5,padding:20}}>
              <CardMedia component="img" image="/icons/folder.svg" alt="up" title={this.getDirName(dir)} onClick={()=>{ this.props.dirClickedFunc(dir)}}/>
              <CardContent>
                  <Typography align="center" variant="body2">{this.getDirName(dir)}</Typography>
              </CardContent>
              <CardActionArea>
                  <Box textAlign="center">
                    <Button component="span" variant='contained' disabled={this.props.hasContents} color='secondary' size='small' onClick={()=>{ this.props.deleteDirFunc(dir) }}>{ETVConstants.trans("delete")}</Button>
                  </Box>
              </CardActionArea>
          </Card>
      )
    }
}

export default DirectoryItem;
